<nb-card>
    <nb-card-header>
        <div class="title">{{title}}</div>
        <div class="action">
            <nb-actions size="small">
                <nb-action>
                    <nb-icon icon="close-circle-outline" pack="eva" (click)="close()"></nb-icon>
                </nb-action>
            </nb-actions>
        </div>
    </nb-card-header>
    <div class="wrapper">
        <div class="directory-listing">
            <ng-container *ngFor="let item of items;let index = index ">
                <div class="directory-entry">
                    <ng-container *ngIf="item.type == 'directory';else fileItem">
                        <div class="icon-container" (click)="selectItem(index,'directory')">
                            <nb-icon icon="folder-outline" pack="eva"></nb-icon>
                        </div>
                        <div class="item-name">{{item?.name}}</div>
                    </ng-container>
                </div>
            </ng-container>
        </div>
        <div class="directory-contents-wrapper">
            <div class="directory-contents">
                <div *ngFor="let item of imageObjects" class="thumbnail" (click)="selectImage($event)">
                    <img src="{{item?.path}}"/>
                </div>
                <!-- <ng-template #fileItem>
                    <div class="icon-container" (click)="selectItem(index,'file')">
                        <img src="{{item?.path}}"/>
                    </div>
                </ng-template> -->
            </div>
        </div>
        <ng-container *ngIf="!isChosen;else finalize">
            <div class="previews">
                <div class="image-preview">
                    <div class="header editor-heading">
                        <div class="existing">
                            <div class="title">
                                Existing
                            </div>
                            <div class="item-wrapper">
                                <div class="header-item">
                                    <div class="label">Orientation:</div><div class="value">{{selectedCell?.imageOrientation}}</div>
                                </div>
                                <div class="header-item">
                                    <div class="label">Width:</div><div class="value">{{selectedCell?.width}}px</div>
                                </div>
                                <div class="header-item">
                                    <div class="label">Height:</div><div class="value">{{selectedCell?.height}}px</div>
                                </div>
                            </div>
                        </div>
                        <div class="new">
                            <div class="title">
                                New
                            </div>
                            <div class="item-wrapper">
                                <div class="header-item">
                                    <div class="label">Orientation:</div><div class="value">{{newImageOrientation}}</div>
                                </div>
                                <div class="header-item">
                                    <div class="label">Width:</div>
                                    <ng-container *ngIf="newImageWidth">
                                        <div class="value">{{newImageWidth}}px</div>
                                    </ng-container>
                                </div>
                                <div class="header-item">
                                    <div class="label">Height:</div>
                                    <ng-container *ngIf="newImageHeight">
                                        <div class="value">{{newImageHeight}}px</div>
                                    </ng-container>
                                </div>
                                <div class="header-item">
                                    <ng-container *ngIf="imageCompatibility">
                                        Compatible
                                    </ng-container>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="existing-image-wrapper">
                        <div class="image-wrapper">
                            <img src="{{imgSrc}}">
                        </div>
                        
                            <div class="new-image" [ngClass]="newImageOrientation == 'landscape' ? 'align-self': 'dummy'">
                                <img src="{{newImgSrc}}" class="candidate-image">
                                <ng-container *ngIf="isSelected">
                                        <div class="rejected-notice">
                                            <ng-container *ngIf="!imageCompatibility;else compatible">
                                                <div class="notice-text">Choose a different image or upload a new one. This one isn't the right size or orientation.</div>
                                                <div class="action-button"><button nbButton size="tiny" status="danger" (click)="onUseImage()">Use Any Way</button></div>
                                            </ng-container>
                                            <ng-template #compatible>
                                                <div class="action-button"><button nbButton size="small" status="primary" (click)="onUseImage()">Use Image<nb-icon icon="checkmark-outline" pack="eva" status="primary"></nb-icon></button></div>
                                            </ng-template>
                                        </div>
                                    
                                </ng-container>
                            </div>
                        
                        
                        <!-- <div>
                            <input type="file" class="file-input" (change)="onFileSelected($event)" #fileUpload>
                            <div class="file-upload">
                                
                                <button nbButton status="primary" (click)="fileUpload.click()" size="tiny"><nb-icon icon="upload-outline"></nb-icon>{{fileName || "No file uploaded yet."}}</button>
                            </div>
                        </div> -->
                    </div>
                </div>
            </div>
        </ng-container>
        <ng-template #finalize>
            <div class="previews finalize">
                <div class="header editor-heading">
                    <nb-actions>
                        <nb-action title="Save" (click)="onSaveImage()">
                            <nb-icon class="toggle-icon" icon="save-outline" pack="eva">Save</nb-icon>
                        </nb-action>
                        <nb-action title="Undo" (click)="onUndo()">
                            <nb-icon class="toggle-icon" icon="undo-outline" pack="eva">Undo</nb-icon>
                        </nb-action>
                        <nb-action title="Cancel" (click)="onCancel()">
                            <nb-icon class="toggle-icon" icon="backspace-outline" pack="eva">Reset</nb-icon>
                        </nb-action>
                    </nb-actions>
                </div>
                <div class="existing-image-wrapper">
                    <div class="image-wrapper">
                        <img src="{{imgSrc}}">
                    </div>
                </div>
            </div>
        </ng-template>
    </div>
</nb-card>

